module.exports = __webpack_public_path__ + "static/img/dDR2.319ab756.png";